<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="banner-slider-wrap">
    <swiper class="mySwiper" ref="swiperRef" :modules="modules" :autoplay="{
      delay: 3500,
      disableOnInteraction: false,
    }" @swiper="onSwiper">
      <swiper-slide v-for="(bannerItem, index) in bannerList" :key="index">
        <div class="banner-wrap">
          <div class="content-wrap">
            <div class="container">
              <!-- <div class="timer" v-if="bannerItem.timer">
                <img src="@/assets/images/clock.svg" alt="clock" />
                {{ bannerItem.timer }}
              </div> -->
              <div class="content">
                <!-- <h1>{{ bannerItem.title }}</h1> -->
                <h1 v-if="bannerItem.label" class="title">Онлайн захиалга</h1>
                <p v-if="bannerItem.description" class="__kfc_r_4 description">Амтат шарсан тахиагаа онлайнаар захиалаад амралтын өдрийг гэр бүлтэйгээ
                  өнгөрүүлээрэй.</p>
                <!-- <p>{{ bannerItem.description }}</p> -->
                <button v-if="bannerItem.button" class="__kfc_button __kfc_button_red">Захиалах</button>
              </div>
              <div class="bottom __kfc_flex">
                <div class="pagination __kfc_flex">
                  <span class="__kfc_r_8 number">
                    0{{ index + 1 }}
                  </span>
                  <span class="__kfc_color_red">/</span>
                  <span class="__kfc_r_8 number">0{{ bannerList.length }}</span>
                </div>
                <div class="__kfc_flex navigation">
                  <div class="back" @click="prevSlide">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                      <path
                        d="M14.2241 2.49158C14.1274 2.39457 14.0124 2.3176 13.8859 2.26509C13.7593 2.21258 13.6237 2.18555 13.4866 2.18555C13.3496 2.18555 13.214 2.21258 13.0874 2.26509C12.9609 2.3176 12.8459 2.39457 12.7491 2.49158L5.82415 9.41658C5.74689 9.49367 5.68561 9.58524 5.64379 9.68606C5.60197 9.78687 5.58044 9.89494 5.58044 10.0041C5.58044 10.1132 5.60197 10.2213 5.64379 10.3221C5.68561 10.4229 5.74689 10.5145 5.82415 10.5916L12.7491 17.5166C13.1575 17.9249 13.8158 17.9249 14.2241 17.5166C14.6325 17.1082 14.6325 16.4499 14.2241 16.0416L8.19081 9.99991L14.2325 3.95824C14.6325 3.55824 14.6325 2.89158 14.2241 2.49158Z"
                        fill="white" />
                    </svg>
                  </div>
                  <div class="back" @click="nextSlide">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                      <path
                        d="M6.52414 17.5083C6.93248 17.9166 7.59081 17.9166 7.99914 17.5083L14.9241 10.5833C15.0014 10.5062 15.0627 10.4146 15.1045 10.3138C15.1463 10.213 15.1678 10.1049 15.1678 9.99575C15.1678 9.88661 15.1463 9.77854 15.1045 9.67773C15.0627 9.57692 15.0014 9.48535 14.9241 9.40825L7.99914 2.48325C7.59081 2.07492 6.93248 2.07492 6.52414 2.48325C6.11581 2.89159 6.11581 3.54992 6.52414 3.95825L12.5575 9.99992L6.51581 16.0416C6.11581 16.4416 6.11581 17.1083 6.52414 17.5083Z"
                        fill="white" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="numbers container" ref="myDiv">
            0{{ index + 1 }} <span>/</span> 0{{ bannerList.length }}
          </div> -->
          <div class="img-wrap">
            <img :src="cdn + bannerItem.img_url" alt="Image 1" />
            <div class="shadow"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
  import { ref } from 'vue';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/autoplay';
  import Req from "@/utils/Request";
  
  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    setup() {
      const bannerList = ref([]);
      const mySwiper = ref(null);
      const cdn = ref(`${process.env.VUE_APP_CLOUDFRONT_IMAGE_PATH}/resize`);
      const onSwiper = (swiper) => {
        mySwiper.value = swiper;
      };
  
      const prevSlide = () => mySwiper.value?.slidePrev();
      const nextSlide = () => mySwiper.value?.slideNext();

      const getBannerList = async () => {
        const { data: result } = await Req({ url: "/banners/getBanner", hideSuccess: true });
        if (result.success) {
          bannerList.value = result.result
            .filter(item => item.is_active === 1)
            .sort((a,b) => a.sort - b.sort);
        }
      };
  
      getBannerList();
  
      return {
        Swiper,
        SwiperSlide,
        modules: [Autoplay],
        bannerList,
        mySwiper,
        cdn,
        onSwiper,
        prevSlide,
        nextSlide
      };
    }
  };
  </script>
  

<style lang="scss">
.banner-slider-wrap {
  height: 30vw;
  width: 100%;
  @media (max-width: 768px) {
  height: 500px;

  }

  .swiper {
    height: 100%;
    width: 100%;
    position: relative;

    .swiper-wrapper {
      height: 100%;
      width: 100%;

      .swiper-slide {
        height: 100%;
        width: 100%;

        .banner-wrap {
          height: 100%;
          width: 100%;
          position: relative;

          .content-wrap {
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 90%;

            .container {
              display: flex;
              justify-content: center;
              flex-direction: column;
              justify-content: space-between;
              // gap: 12px;
              height: 100%;

              .content {
                width: 100%;
                margin-top: 3%;

                .title {
                  margin: 0;
                  padding: 0;
                  color: $whiteMain;
                  font-family: Oswald;
                  font-size: 60px;
                  font-weight: 700;
                  line-height: 76px;
                  /* 126.667% */
                  text-transform: uppercase;
                }

                .description {
                  color: $whiteMain;
                  width: 50%;
                }

                .__kfc_button {
                  padding: 10px 30px;
                }
              }

              .bottom {
                gap: 32px;
                align-items: center;

                .pagination {
                  gap: 16px;

                  .number {
                    color: $whiteMain;
                  }
                }

                .navigation {
                  display: flex;
                  gap: 12px;

                  .back {
                    width: 38px;
                    height: 38px;
                    align-items: center;
                    display: flex;
                    background: rgba(255, 255, 255, 0.2);
                    justify-content: center;
                    border-radius: 50%;
                    cursor: pointer;
                  }
                }
              }

            }
          }

          .numbers {
            position: absolute;
            bottom: 60px;
            color: $whiteMain;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            /* 128.571% */
            letter-spacing: -0.3px;
            display: flex;
            gap: 16px;
            z-index: 2;
            left: 0;
            right: 0;

            span {
              color: $redMain;
              font-size: 14px;
              font-weight: 600;
              line-height: 18px;
              /* 128.571% */
              letter-spacing: -0.3px;
            }
          }

          .img-wrap {
            width: 100%;
            height: 100%;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: top;
            }

            .shadow {
              // background: linear-gradient(100deg,
              //     rgba(0, 0, 0, 0.61) 2.57%,
              //     rgba(0, 0, 0, 0.19) 100%);

              background: linear-gradient(108deg,
                  rgba(0, 0, 0, 0.70) 2%,
                  rgba(0, 0, 0, 0.00) 70%);

              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
            }
          }
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      border-radius: 50%;
      width: 38px;
      height: 38px;
      background: #ffffff15;
      color: $whiteMain;
      position: absolute;
      bottom: 50px;
      top: initial;
      right: initial;
    }

    .swiper-button-next {
      left: 500px;
    }

    .swiper-button-prev {
      left: 450px;
    }

    @media screen and (max-width: 1700px) {
      .swiper-button-next {
        left: 400px;
      }

      .swiper-button-prev {
        left: 350px;
      }
    }

    @media screen and (max-width: 1600px) {
      .swiper-button-next {
        left: 350px;
      }

      .swiper-button-prev {
        left: 300px;
      }
    }

    @media screen and (max-width: 1500px) {
      .swiper-button-next {
        left: 300px;
      }

      .swiper-button-prev {
        left: 250px;
      }
    }

    @media screen and (max-width: 1400px) {
      .swiper-button-next {
        left: 250px;
      }

      .swiper-button-prev {
        left: 200px;
      }
    }

    @media screen and (max-width: 1300px) {
      .swiper-button-next {
        left: 200px;
      }

      .swiper-button-prev {
        left: 150px;
      }
    }

    @media screen and (max-width: 1200px) {
      .swiper-button-next {
        left: 250px;
      }

      .swiper-button-prev {
        left: 200px;
      }
    }

    @media screen and (max-width: 760px) {
      .swiper-wrapper {
        .swiper-slide {
          .banner-wrap {
            .content-wrap {
              .container {
                h1 {
                  font-size: 40px;
                  line-height: 56px;
                }

                p {
                  width: 90%;
                }
              }
            }
          }
        }
      }

      .swiper-button-next {
        left: 180px;
      }

      .swiper-button-prev {
        left: 130px;
      }
    }

    .swiper-button-next:after,
    .swiper-button-prev:after {
      font-size: 16px;
    }
  }
}
</style>
